import { use } from 'react'

import { LookContext } from '#providers/LookProvider'
import type { TLook } from '#providers/LookProvider/interfaces'

/** The current look (FE-013): classic for admins and klantadmins, app for travellers. */
export function useLook(): TLook {
  return use(LookContext).look
}
